import { Component, Input, OnInit } from '@angular/core';
import { BaseReportCardComponent } from '../base-report-card.component';
import { ReportWithDatesRequest, ReportGenSvc, SalesTotalsViewModel } from 'src/app/services_autogenerated/generated_services';
import { Chart } from 'chart.js';
import { RmDateRangeServiceService } from 'src/app/services/rm-date-range-service.service';

@Component({
    selector: 'app-completed-paid-totals',
    templateUrl: './completed-paid-totals.component.html',
    styleUrls: ['./completed-paid-totals.component.css'],
    standalone: false
})
export class CompletedPaidTotalsComponent extends BaseReportCardComponent implements OnInit {
  @Input() mainColor: string = 'rgb(33, 37, 41)';

  totalsLoading: boolean = true;
  totals: SalesTotalsViewModel;

  constructor(private reportService: ReportGenSvc,
    private rmDashboardDateRangeService: RmDateRangeServiceService
  ) {
    super();
  }

  ngOnInit() {
    this.rmDashboardDateRangeService.getDateRangeUpdater().subscribe(changed => {
      this.totalsLoading = true;
      this.startDate = changed.start;
      this.endDate = changed.end;
      
      this.reportService.getCompletedPaidTotals(new ReportWithDatesRequest({
        id: !this.companyWide ? this.employee.id : null,
        afterDate: this.startDate,
        beforeDate: this.endDate
      })).subscribe(res => {
        this.totalsLoading = false;
        this.totals = res;
      });
    });
  }
}
